<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <!-- 画面タイトル -->
        <div class="l-top-navi__heading-area">
          <h1 class="l-top-navi__heading-text" [innerHTML]="'label.anabizlogoutSubheader' | staticMsg"></h1>
        </div>
      </div>
    </div>
  </div>
</div>
